import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTrash = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 12,
	height: 13,
	viewBox: "0 0 12 13",
	fill: "none",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("g", {
			clipPath: "url(#clip0_2487_2267)",
			children: /* @__PURE__ */ _jsx("path", {
				d: "M11.3125 2H8.875L8.07812 0.96875C7.89062 0.710938 7.49219 0.5 7.1875 0.5H5.3125C4.98438 0.5 4.58594 0.710938 4.39844 0.96875L3.625 2H1.1875C1.07031 2 1 2.09375 1 2.1875V2.5625C1 2.67969 1.07031 2.75 1.1875 2.75H1.60938L2.40625 11.4922C2.45312 12.0547 2.94531 12.5 3.50781 12.5H8.96875C9.53125 12.5 10.0234 12.0547 10.0703 11.4922L10.8672 2.75H11.3125C11.4062 2.75 11.5 2.67969 11.5 2.5625V2.1875C11.5 2.09375 11.4062 2 11.3125 2ZM5.00781 1.41406C5.05469 1.32031 5.19531 1.27344 5.3125 1.25H7.1875C7.28125 1.27344 7.42188 1.32031 7.46875 1.41406L7.9375 2H4.5625L5.00781 1.41406ZM9.34375 11.4219C9.32031 11.6094 9.15625 11.75 8.96875 11.75H3.50781C3.32031 11.75 3.15625 11.6094 3.15625 11.4219L2.38281 2.75H10.1172L9.34375 11.4219Z",
				fill: "#313131"
			})
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
			id: "clip0_2487_2267",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 12,
				height: 12,
				fill: "white",
				transform: "translate(0 0.5)"
			})
		}) })
	]
});
const ForwardRef = forwardRef(SvgTrash);
export { ForwardRef as ReactComponent };
